const { ajax_url, nonce_field, nonce_value } = vendoraObject;

/**
 * Dynamic nonce updater to fix cache issue.
 * 
 * @since 1.4.0
 */
(function updateNonce() {
    const formData = new FormData();
    formData.set('action', 'vendora_nonce')

    fetch(ajax_url, {
        method: 'POST',
        body: formData,
    }).then(response => response.json())
        .then(res => {
            if (res.success) {
                vendoraObject.nonce_value = res.data
                let nonceField = document.querySelector(`input[name="${nonce_field}"]`)
                if (nonceField) {
                    nonceField.value = res.data
                }
            }
        });

})();
